import { Button, Icon } from '@sr/ui-library';
import { Link, useLocation, useParams } from 'react-router-dom';
import { withoutEmbedWorkflowParams } from '../utils/embedWorkflow';

/**
 * Entry point to the Add Title interim page, where the user picks what they are
 * registering. MSR2 embed availability is checked there, on the action that
 * opens the registration, so a non-member can still reach the page to apply for
 * membership.
 */
const AddTitleLink = () => {
  const { workspaceId } = useParams();
  const { pathname, search } = useLocation();

  if (!workspaceId) {
    return null;
  }

  // This button stays visible while its host page has handed its body to
  // `EmbeddedWorkflowView`, so the current search can carry an active `?src=`.
  // Dropping it here keeps Back pointing at the host page rather than at the
  // workflow the user left to come here.
  const openedFromSearch = withoutEmbedWorkflowParams(
    new URLSearchParams(search),
  ).toString();

  return (
    <Button
      asChild
      sectionLeft={<Icon className="rotate-90" icon="filmStrip" />}
    >
      {/* The page records where it was opened from: its Back cannot rely on
          history, because the MSR2 embed's own navigations pile up entries in
          the joint session history. */}
      <Link
        state={{
          addTitleFrom: openedFromSearch
            ? `${pathname}?${openedFromSearch}`
            : pathname,
        }}
        to={`/workspace/${workspaceId}/add-title`}
      >
        Add Title
      </Link>
    </Button>
  );
};

export default AddTitleLink;
